export const SET_PRODUCTS = "SET_PRODUCTS";
export const ADD_WAREHOUSE = "ADD_WAREHOUSE";
export const SET_WAREHOUSES = "SET_WAREHOUSES";
export const UPDATE_WAREHOUSE = "UPDATE_WAREHOUSE";
export const DELETE_WAREHOUSE = "DELETE_WAREHOUSE";
export const SET_WAREHOUSES_STOCK_LOGS = "SET_WAREHOUSES_STOCK_LOGS";
